import { useState, useEffect } from 'react';

import { servGetGruposPorCPF, servAssociaGrupo, servDesassociaGrupo } from '../../servicos/servicosEmRotasPrivadas/grupo_usuario';

import minusIcon from '../../imagens/minus.png'
import plusIcon from '../../imagens/plus-sign.png'

import toast from 'react-hot-toast';
import smartToast from '../../util/smart_toast';
import { formatCPF, toastErrorFromResponse } from '../../util/utilitarios';

import Modal from 'react-bootstrap/Modal';
import TituloSessao from '../TituloSessao';

function ModalAssociaGrupoUsuario({ showModalGrupoUsuario, setShowModalGrupoUsuario }) {

    console.log('### Iniciando ModalAssociaGrupoUsuario ###');

    const [grupos, setGrupos] = useState(null)
    const [cpf, setCpf] = useState(null)

    const getGruposPorCPF = async () => {

        if (cpf == null) {
            toast.error('Digite o CPF na barra de busca')
            return
        }

        if (cpf.length !== 11) {
            toast.error('O CPF deve conter 11 dígitos')
            return
        }

        try {
            const gruposDaApi = await toast.promise(
                servGetGruposPorCPF(cpf),
                { loading: 'Buscando permissões associadas ao usuário...' }
            )
            console.log(grupos);
            setGrupos(gruposDaApi.data);

        } catch (error) {
            setGrupos(null);
            toastErrorFromResponse(error);
        }
    }

    const associaGrupo = async (cpf, grupoId) => {

        try {

            const associao = { cpf: cpf, grupoId: grupoId }

            await toast.promise(
                servAssociaGrupo(associao),
                { loading: 'Associando Grupo...' }
            )

            getGruposPorCPF()

        } catch (error) {
            toastErrorFromResponse(error);
        }
    }

    const desassociaGrupo = async (grupoUsuarioId, usuarioId) => {

        try {

            await smartToast(
                servDesassociaGrupo(grupoUsuarioId, usuarioId),
                { loadingMessage: 'Desassociando Grupo...' }
            );

            getGruposPorCPF()

        } catch (error) {
            toastErrorFromResponse(error);
        }
    }


    return (
        <div className="d-flex justify-content-center mt-3">

            <Modal show={showModalGrupoUsuario} onHide={() => setShowModalGrupoUsuario(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Associar Usuário à Grupos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <p>Informe o CPF do usuario.</p> */}
                    <div className="container-fluid p-2">
                        {grupos ? <TituloSessao titulo={`CPF ${formatCPF(cpf)}`} barraDecorativa={false} /> : <p>Informe o CPF do usuario.</p>}
                        <form className="d-flex gap-3 align-items-center">
                            <a className="navbar-brand">CPF</a>
                            <input
                                className="form-control me-2"
                                type="search"
                                placeholder="Search"
                                aria-label="Search"
                                onBlur={(e) => {
                                    const somenteNumeros = e.target.value.replace(/\D/g, "");
                                    setCpf(somenteNumeros);
                                }}
                                defaultValue={cpf}
                            />
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={getGruposPorCPF}
                            >
                                BUSCAR
                            </button>
                        </form>
                    </div>

                    {grupos &&
                        <>
                            <div className='text-center'>
                                <p className="fs-5" id="exampleModalLabel">Grupos Associados</p>

                                {
                                    grupos.associados.length < 1
                                        ?
                                        <p>Não há grupos associados a este usuário</p>
                                        :
                                        <ul className="list-group">
                                            {grupos.associados.map((grupo) =>
                                                <li key={grupo.grupoId}
                                                    className="list-group-item d-flex justify-content-between">{grupo.grupo}
                                                    <img
                                                        className='minusAndPlusIcon'
                                                        style={{ 'width': '1.5em' }}
                                                        alt='icone de diminuicao'
                                                        src={minusIcon}
                                                        onClick={() => desassociaGrupo(grupo.grupoId, grupo.usuarioId)}
                                                    />
                                                </li>
                                            )}
                                        </ul>
                                }
                            </div>
                            <div className='text-center mt-3'>
                                <p className="fs-5" id="exampleModalLabel">Associar Grupos</p>

                                {
                                    grupos.naoAssociados.length < 1
                                        ?
                                        <p>Não há grupos disponíveis para associação</p>
                                        :
                                        <ul className="list-group">
                                            {grupos.naoAssociados.map((grupo) =>
                                                <li key={grupo.id}
                                                    className="list-group-item d-flex justify-content-between">{grupo.descricao}
                                                    <img
                                                        className='minusAndPlusIcon'
                                                        style={{ 'width': '1.5em' }}
                                                        alt='icone de diminuicao'
                                                        src={plusIcon}
                                                        onClick={() => associaGrupo(cpf, grupo.id)}
                                                    />
                                                </li>

                                            )}
                                        </ul>
                                }


                            </div>
                        </>
                    }

                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-primary"
                        onClick={() => setShowModalGrupoUsuario(false)}
                    >
                        FECHAR
                    </button>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default ModalAssociaGrupoUsuario;